/**
 * Perform an action on a given subject
 * and return it.
 */
export function transient<Type>(handler: (subject: Type) => any): (subject: Type) => Type {
  return (subject: Type) => {
    handler(subject);
    return subject;
  }
}
